import { Button, Paper } from "@mui/material";
import { ErrorOutlineTwoTone as ErrorIcon } from "@mui/icons-material";
import React from "react";

// Use inline styles instead of makeStyles to avoid theme dependency
// This ensures ErrorDialog works even when rendered outside ThemeProvider
const styles = {
  root: {
    display: "flex",
    padding: "24px",
    marginTop: "40px",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 500,
  },
  text: {
    marginBottom: "24px",
  },
  icon: {
    marginRight: "16px",
    flexGrow: 0,
  },
  message: {
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: 1.6,
    flexGrow: 1,
  },
};

const EnvironmentErrorDialog = () => {
  return (
    <Paper key="error" style={styles.root} variant="outlined">
      <div style={styles.icon}>
        <ErrorIcon fontSize="large" />
      </div>
      <div style={styles.message}>
        <div style={styles.text}>
          {
            "We're sorry but something went wrong. We've been notified about this issue and we'll take a look at it shortly."
          }
        </div>
        <div style={{ textAlign: "right" }}>
          <Button variant="contained" color="primary" component="a" href="/">
            Continue
          </Button>
        </div>
      </div>
    </Paper>
  );
};
export default EnvironmentErrorDialog;
